// Physician Notification subsection form field enum
export enum PhysicianNotificationFormField {
  PHYSICIAN_NOTIFICATION_TEMP_LESS = 'medicalBackground/physicianNotification/tempLess',
  PHYSICIAN_NOTIFICATION_TEMP_GREATER = 'medicalBackground/physicianNotification/tempGreater',
  PHYSICIAN_NOTIFICATION_PULSE_LESS = 'medicalBackground/physicianNotification/pulseLess',
  PHYSICIAN_NOTIFICATION_PULSE_GREATER = 'medicalBackground/physicianNotification/pulseGreater',
  PHYSICIAN_NOTIFICATION_RESPIRATIONS_LESS = 'medicalBackground/physicianNotification/respirationsLess',
  PHYSICIAN_NOTIFICATION_RESPIRATIONS_GREATER = 'medicalBackground/physicianNotification/respirationsGreater',
  PHYSICIAN_NOTIFICATION_BP_LESS = 'medicalBackground/physicianNotification/bpLess',
  PHYSICIAN_NOTIFICATION_BP_GREATER = 'medicalBackground/physicianNotification/bpGreater',
  PHYSICIAN_NOTIFICATION_WEIGHT_LESS = 'medicalBackground/physicianNotification/weightLess',
  PHYSICIAN_NOTIFICATION_WEIGHT_GREATER = 'medicalBackground/physicianNotification/weightGreater',
  PHYSICIAN_NOTIFICATION_ETCO2_SATURATION_LESS = 'medicalBackground/physicianNotification/etco2SaturationLess',
  PHYSICIAN_NOTIFICATION_ETCO2_SATURATION_GREATER = 'medicalBackground/physicianNotification/etco2SaturationGreater',
  PHYSICIAN_NOTIFICATION_O2_SATURATION_LESS = 'medicalBackground/physicianNotification/o2SaturationLess',
  PHYSICIAN_NOTIFICATION_O2_SATURATION_GREATER = 'medicalBackground/physicianNotification/o2SaturationGreater'
}
